import React, { useEffect, useRef, useState } from 'react';
import ThreeJSViewer from '../../core/viewer/ThreeJSViewer';

function AircraftViewer({ modelFile, components, onComponentHover, debugMode = false }) {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!canvasRef.current || !containerRef.current) return;

    // Create viewer
    const viewer = new ThreeJSViewer(canvasRef.current, containerRef.current);
    viewerRef.current = viewer;

    // Load model
    viewer
      .loadModel(modelFile, components, onComponentHover, debugMode)
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to load model:', err);
        setError('Error loading 3D model. Please refresh the page.');
        setLoading(false);
      });

    // Cleanup on unmount
    return () => {
      if (viewerRef.current) {
        viewerRef.current.dispose();
      }
    };
  }, [modelFile, components, onComponentHover, debugMode]);

  return (
    <div className="model-container" ref={containerRef}>
      <canvas id="aircraft-canvas" ref={canvasRef}></canvas>

      {loading && (
        <div className="loading-indicator" id="loadingIndicator">
          <p>Loading 3D Model...</p>
        </div>
      )}

      {error && (
        <div className="loading-indicator">
          <p>{error}</p>
        </div>
      )}
    </div>
  );
}

export default AircraftViewer;
